export default "8dece253e54cb4e3.svg"